import { observable, runInAction } from 'mobx';
import { FooterColumn } from '@teliaee/telia-megamenu';
import { safeReaction } from '../util/MobxUtil';
import LanguageStore from './LanguageStore';
import RootStore from './RootStore';

class FooterStore {
  @observable accessor initialColumns: FooterColumn[];

  private languageStore: LanguageStore;

  constructor(rootStore: RootStore) {
    runInAction(() => {
      this.languageStore = rootStore.languageStore;
      this.init(rootStore.initialState);
      safeReaction(
        rootStore,
        () => this.languageStore.currentLanguage,
        () => this.forgetInitialFooter(),
      );
    });
  }

  public forgetInitialFooter = () => {
    runInAction(() => {
      this.initialColumns = null;
    });
  };

  public init(initialState: InitialState) {
    const { initialLanguageChanged } = this.languageStore;
    if (!initialLanguageChanged && initialState.footerMenu) {
      runInAction(() => {
        this.initialColumns = initialState.footerMenu?.columns;
      });
    }
  }

  get columns(): FooterColumn[] {
    return this.initialColumns;
  }
}

export default FooterStore;
